import { t } from '@lingui/core/macro';
import { OperatorField, OperatorId } from '@luminovo/api-contracts';
import { FieldSelect, FieldSelectProps } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';

import { operatorIdTranslations } from '../../../i18n';

const numericOperatorIds: OperatorId[] = ['Gt', 'Lt', 'Gte', 'Lte', 'Eq'];

const optionsByField: Record<OperatorField, OperatorId[]> = {
    PartType: ['Eq'],
    AggregatedQuantity: numericOperatorIds,
    OrderSize: numericOperatorIds,
    Package: ['In'],
    Packaging: ['Eq'],
    UnitPrice: numericOperatorIds,
    Mounting: ['Eq'],
    PartCategory: ['Eq'],
};

export function FieldScrapOperatorId({
    field,
    ...props
}: Omit<FieldSelectProps<OperatorId>, 'options'> & { field: OperatorField }): JSX.Element {
    const options = optionsByField[field];
    return (
        <FieldSelect
            options={options}
            getOptionLabel={formatOperatorId}
            placeholder={t`Operator`}
            disabled={options.length <= 1}
            {...props}
        />
    );
}

function formatOperatorId(operatorId: OperatorId): string {
    return transEnum(operatorId, operatorIdTranslations);
}
